var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-drawer',{attrs:{"placement":_vm.placement,"closable":false,"visible":_vm._visible,"body-style":_vm.bodyStyle,"drawer-style":_vm.drawerStyle,"width":"208"},on:{"close":_vm.onClose}},[_c('sidebar-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }